import { ReactNode } from 'react';

import MainLayout from 'src/layouts';

interface IProps {
  children: ReactNode;
  hideSideBar?: boolean;
}

const CompanyLayout = ({ children, hideSideBar = false }: IProps) => {
  return <MainLayout hideSideBar={hideSideBar}>{children}</MainLayout>;
};

export default CompanyLayout;
